import { Button } from 'react-bootstrap';
import React from 'react';

const ConfirmButton = React.forwardRef(({ checkBasket, total_gr, isTeammate, isWalletPayment, translate, onConfirm, onShowModal }, ref) => {
  const getButtonText = () => {
    if (!checkBasket) return 'تا تایید نهایی محصولات چند لحظه صبر کنید';
    if (isWalletPayment) return translate('wallet_pay');
    return translate('online_pay');
  };

  const handleClick = () => {
    if (total_gr > 25) {
      onConfirm();
    } else if (isTeammate) {
      onShowModal();
    } else {
      onConfirm();
    }
  };

  return (
    <div
      className='d-flex align-self-center justify-content-center m-0 title c-font-sm btn-sm text-center rounded button-confirm-page'
      style={{
        // width: '100%',
        padding: '10px', // اختیاری برای فضای بهتر
        zIndex: 9999,
      }}
    >
      <Button
        ref={ref}
        disabled={!checkBasket}
        onClick={handleClick}
        className='custom-success-btn btn d-flex align-self-center justify-content-center m-0 title c-font-sm btn-sm text-center rounded'
        style={{ minWidth: '250px' }}
      >
        {getButtonText()}
      </Button>
    </div>
  );
});

export default ConfirmButton;
